@if (evtAlerts$ | async ; as evtAlerts) {
  @for (product of sanitizeAlerts(evtAlerts); track product.name) {
    <div
      class="product"
      >
      <div class="product-headline">
        {{ product.response.length }} alerts for {{ product.name }}
      </div>
      @for (error of product.response; track error.message) {
        <div class="message">{{ error.message }}</div>
      }
    </div>
  }
}
